export const TextScenarioType = {
  0: 'ELSE',
  1: 'BOT_MESSAGE',
  2: 'READ_USER_MESSAGE',
  3: 'GO_TO',
  4: 'ADD_BUTTON',
  5: 'BOT_MESSAGE',
  6: 'GO_TO',
  7: 'VIDEO_BUTTON',
  8: 'VIDEO_LINK',
  9: 'PASS_TO_AI',
  10: 'ASSIGN_VARIABLE',
  11: 'ADD_LINK',
  12: 'HTTP_REQUEST',
  13: 'CONDITIONS',
  14: 'CONDITION_ELSE',
  15: 'OVERRIDE_VARIABLE',
  16: 'CREATE_VARIABLE',
  17: 'LEAD_FORM',
  18: 'SEND_MEDIA',
  19: 'SEND_ATTACHMENT',
  20: 'END_OF_CONVERSATION',
  21: 'DELAY',
  22: 'MAKE_WEBHOOK',
  23: 'NOTIFY_ME_BY_EMAIL',
  24: 'RECEIVE_ATTACHMENT',
  25: 'SUPER_USER_MANAGER_SERVICES',
  27: 'REGISTER_USER',
  28: 'GET_USER_INFO',
  29: 'CHECK_IF_USER_EXISTS',
  30: 'USER_CREDENTIAL',
  31: 'SWITCH_TO_CHATBOT',
  32: 'SPEECH_RECORDING',
  33: 'ASK_TO_AI',
  34: 'SUMMARIZE_CONVERSATION',
  35: 'JS_CODE',
  1000: 'START_POINT',
};
